import { render, staticRenderFns } from "./HoldTxnDetails.vue?vue&type=template&id=6ab3653c&scoped=true"
import script from "./HoldTxnDetails.vue?vue&type=script&lang=js"
export * from "./HoldTxnDetails.vue?vue&type=script&lang=js"
import style0 from "./HoldTxnDetails.vue?vue&type=style&index=0&id=6ab3653c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab3653c",
  null
  
)

export default component.exports